import Vue from 'vue';
import moment from 'moment';
import Settings from '../../../config/settings';
import filters from '../../filters';
import template from './index.html';

const phase2Date = Settings.phases.phase2Date;

const calculateDifference = () => {
  const now = moment();
  const duration = moment.duration(phase2Date.diff(now));
  const seconds = duration.asSeconds();

  return seconds;
};

export default Vue.extend({
  name: 'Counter',
  template,
  computed: {
    seconds() {
      return filters.digits(this.secondsDiff % 60);
    },
    minutes() {
      return filters.digits(Math.trunc((this.secondsDiff) / 60) % 60);
    },
    hours() {
      return filters.digits(Math.trunc((this.secondsDiff) / 60 / 60) % 24);
    },
    days() {
      return filters.digits(Math.trunc((this.secondsDiff) / 60 / 60 / 24));
    },
    timelineWidth() {
      const seconds = this.secondsDiff % 60;
      return filters.digits((seconds / 60) * 100);
    },
  },
  data() {
    return {
      secondsDiff: 0,
    };
  },

  mounted() {
    window.setInterval(() => {
      this.secondsDiff = calculateDifference();
    }, 1000);
  },
});



// WEBPACK FOOTER //
// ./src/js/components/counter/index.js